import _ from 'lodash';
import React from 'react';
import {connect} from 'react-redux';

import ErrorBlock from 'components/ErrorBlock';
import {
  AddNoteButton,
  AddNoteForm,
  NotesFilters,
  NoteBlock
} from 'components/Notes/';
import {
  selectIsAddRoomNoteFormOpened,
  toggleAddRoomNoteForm,
  fetchRoomNotes,
  addRoomNote,
  selectRoomNotes,
  setRoomNoteForEdit,
  editRoomNote,
  archiveRoomNote,
  restoreRoomNote,
  selectRoomNoteForEdit,
  selectRoomNotesErrors
} from 'ducks/notes';
import {requiresPermission, PERMISSIONS} from 'ducks/auth';

import './styles.css';

class RoomNotes extends React.Component<any> {
  toggleAddRoomNoteForm = ({isOpened}) => {
    this.props.requiresPermission(
      {
        locationRef: this.props.locationRef,
        permission: PERMISSIONS.CREATE_ROOM_NOTE
      },
      () => this.props.toggleAddRoomNoteForm({isOpened})
    );
  };

  filterActiveNotes = () => {
    this.fetchRoomNotes({archived: false});
  };

  filterArchivedNotes = () => {
    this.fetchRoomNotes({archived: true});
  };

  submitAddNoteForm = ({noteText}) => {
    this.props.requiresPermission(
      {
        locationRef: this.props.locationRef,
        permission: PERMISSIONS.CREATE_ROOM_NOTE
      },
      () => {
        const {roomId} = this.props;
        this.props.addRoomNote({roomId, text: noteText}, [
          () => fetchRoomNotes({roomId, archived: false}),
          () => toggleAddRoomNoteForm({isOpened: false}),
          ...this.props.refetchExtraAction()
        ]);
      }
    );
  };

  archiveNote = ({noteId}) => {
    this.props.requiresPermission(
      {
        locationRef: this.props.locationRef,
        permission: PERMISSIONS.EDIT_ROOM_NOTE
      },
      () => {
        const {roomId} = this.props;
        this.props.archiveRoomNote({note: noteId}, [
          () => fetchRoomNotes({roomId, archived: false})
        ]);
      }
    );
  };

  restoreNote = ({noteId}) => {
    this.props.requiresPermission(
      {
        locationRef: this.props.locationRef,
        permission: PERMISSIONS.EDIT_ROOM_NOTE
      },
      () => {
        const {roomId} = this.props;
        this.props.restoreRoomNote({note: noteId}, [
          () => fetchRoomNotes({roomId, archived: true})
        ]);
      }
    );
  };

  submitEditNoteForm = ({text, noteId}) => {
    this.props.requiresPermission(
      {
        locationRef: this.props.locationRef,
        permission: PERMISSIONS.EDIT_ROOM_NOTE
      },
      () => {
        const {roomId} = this.props;
        this.props.editRoomNote({text, note: noteId, roomId}, [
          () => fetchRoomNotes({roomId, archived: false}),
          () => setRoomNoteForEdit({noteId: null}),
          ...this.props.refetchExtraAction()
        ]);
      }
    );
  };

  setNoteForEdit = ({noteId}) => {
    this.props.requiresPermission(
      {
        locationRef: this.props.locationRef,
        permission: PERMISSIONS.EDIT_ROOM_NOTE
      },
      () => {
        this.props.setRoomNoteForEdit({noteId});
      }
    );
  };

  fetchRoomNotes = ({archived}) => {
    const {roomId} = this.props;
    this.props.fetchRoomNotes({roomId, archived});
  };

  componentDidMount() {
    this.fetchRoomNotes({archived: false});
  }

  render() {
    const {isAddRoomNoteFormOpen, roomNotes, errors} = this.props;

    return (
      <div className="RoomNotes">
        {!isAddRoomNoteFormOpen && (
          <div className="roomNotesActions">
            <AddNoteButton
              openAddNoteForm={() =>
                this.toggleAddRoomNoteForm({isOpened: true})
              }
            />
            <NotesFilters
              filterActiveNotes={this.filterActiveNotes}
              filterArchivedNotes={this.filterArchivedNotes}
            />
          </div>
        )}
        {isAddRoomNoteFormOpen && (
          <AddNoteForm
            formName="addRoomNote"
            closeForm={() => this.toggleAddRoomNoteForm({isOpened: false})}
            submitAction={this.submitAddNoteForm}
          />
        )}
        {_.map(errors, (error, key) => (
          <ErrorBlock key={key}>{error}</ErrorBlock>
        ))}
        <div className="timeHeading">Now</div>
        <div className="notes">
          {roomNotes.map(note => (
            <NoteBlock
              key={note.id}
              note={note}
              archiveNote={this.archiveNote}
              restoreNote={this.restoreNote}
              submitEditNoteForm={this.submitEditNoteForm}
              setNoteForEdit={this.setNoteForEdit}
              addOptions={true}
              editNote={true}
              editNoteSelector={selectRoomNoteForEdit}
              optionsDropdownClassName="RoomNotesDropdown"
              editFormName="editRoomNote"
            />
          ))}
        </div>
        <div className="timeHeading">The beginning of time</div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    errors: _.get(selectRoomNotesErrors(state), '_error'),
    roomNotes: selectRoomNotes(state),
    isAddRoomNoteFormOpen: selectIsAddRoomNoteFormOpened(state)
  };
};

const mapDispatchToProps = {
  toggleAddRoomNoteForm,
  fetchRoomNotes,
  addRoomNote,
  setRoomNoteForEdit,
  editRoomNote,
  restoreRoomNote,
  archiveRoomNote,
  requiresPermission
};

export default connect(mapStateToProps, mapDispatchToProps)(RoomNotes);
